import { useApp } from '../context/AppContext'
import { useTheme } from '../hooks/useTheme'

export default function BottomNav() {
  const { page, navigate } = useApp()
  const { bgWhite, borderColor, textMuted, isDark } = useTheme()

  const NAV_ITEMS = [
    { page: 'learn',   icon: 'fa-graduation-cap', label: '学习' },
    { page: 'courses', icon: 'fa-book-open',    label: '知识' },
    { page: 'cart',    icon: 'fa-shuffle',       label: '说灵灵' },
    { page: 'ai',      icon: 'fa-comments',      label: 'AI问答' },
    { page: 'profile', icon: 'fa-circle-user',  label: '我的' },
  ]

  return (
    <nav className="flex-shrink-0 h-16 flex items-center border-t z-20"
         style={{ background: bgWhite, borderColor: borderColor, boxShadow: isDark ? '0 -4px 20px rgba(0,0,0,0.3)' : '0 -4px 20px rgba(0,0,0,0.05)' }}>
      {NAV_ITEMS.map(item => {
        const active = page === item.page
        return (
          <button
            key={item.page}
            className="flex-1 flex flex-col items-center justify-center gap-1 py-2 border-none bg-transparent cursor-pointer transition-all relative"
            style={{ color: active ? '#6C63FF' : textMuted }}
            onClick={() => navigate(item.page)}
          >
            <div className="relative">
              <i className={`fa-solid ${item.icon} text-xl transition-transform ${active ? 'scale-110' : ''}`} />
            </div>
            {item.label && <span className="text-[10px] font-medium">{item.label}</span>}
          </button>
        )
      })}
    </nav>
  )
}
